export default {
  menswear: [32, 34, 36, 38, 40, 42, 44, 46, 48, 50],
  womenswear: [28, 30, 32, 34, 36, 38, 40, 42, 44, 46],
}
